export default {
	formData: {
		Manager2Role:"",
		Manager2FirstName: "",
		Manager2LastName: "",
		Manager2Email: "",
		Manager2Phone: "",
		Id: "",
		CompanyName: "",
		CompanyEmail: "",
		CompanyPhone: "",
		CompanyAddressLine1: "",
		CompanyAddressLine2: "",
		CompanyAddress: "",
		CompanyCity: "",
		CompanyProvince: "",
		CompanyPostalCode: "",
		CompanyCountry: "Canada",
		CompanyContactId: "",
		ProductionType: "",
		ProductionTitle: "",
		ProductionType_EpisodeNumber: "",
		ProductionType_Other: "",
		Prep_StartDate: "",
		Prep_EndDate: "",
		Filming_StartDate: "",
		Filming_EndDate: "",
		Wrap_StartDate: "",
		Wrap_EndDate: "",
		Weather_Date: "",
		NumOfVehicles: "",
		NumOfCastCrew: "",
		TOTALPRODBUDGET: "",
		TOTCADCB: "Y",
		TOTALUSDCB: "N",
		ESTSPEND: "",
		ESTCADCB: "Y",
		ESTUSDCB: "N",
		Consent_CityCredit: 'N',
		FILMINTERIOR: 'N',
		FILMEXT: "N",
		FILMFRONT: "N",
		FILMBACK: "N",
		FILMOTHER: "N",
		EQRW: "N",
		EQBLVD: "N",
		EQSW: "N",
		CAMCAR: "N",
		CityGrid: "N",
		TOWRIG: "N",
		VEHPULLUP: "N",
		VEHPULLLOC: "",
		TRAVSHOOT: "N",
		TRVSHOTLOC: "",
		TRAFSTOP: "N",
		UserEmail: "",
		POLSTOPLOC: "", //Traffic stop location
		FX: "N",
		SPFXDESC: "",
		UAV: "N",
		SPECINSTR: "",
		Facility_Building_Name: "",
		Facility_Building_StartDate: '',
		Facility_Building_EndDate: '',
		Facility_Building_AssetId: '',
		Facility_Park_Name: '',
		Facility_Park_StartDate: '',
		Facility_Park_EndDate: '',
		Facility_Park_AssetId: '',
		SelectedFilmingLocationList: [
			{ AddressName: '', AddressNumber: '', AddressKey: '' },
			{ AddressName: '', AddressNumber: '', AddressKey: '' }
		],
		SelectedStreetRoadList: [
			/*
			{
				"StreetRoad": "ABRUZ BLVD",
				"Intersection_From": "ABRUZ BLVD/ALTERSEN PL",
				"Intersection_To": "ABRUZ BLVD/OLD PHEASANT RD",
				"StreetRoadStartDate": "2019-05-08 00:00:01",
				"StreetRoadEndDate": "2019-05-08 00:00:01",
				"StreetRoadSide": "",
				"StreetRoadUseType": "parking",
				"OverNight": "Y"
			}
			*/
		],
		SelectedParkingLocationList: [
			/*
			{
				"Location": "Parking Location 01",
				"NumOfSpaces": 0,
				"LocationStartDate": "2019-01-01 00:00:01",
				"LocationEndDate": "2019-01-02 00:00:01",
				"Private": "N",
				"OverNight": "N"
			}
			*/
		],
		Agreement: "N",
		Recaptcha_Token: "",
		Step:1,
		SavedAppId: 0,
		LocManagerFirstName: "",
		LocManagerLastName: "",
		LocManagerEmail: "",
		LocManagerPhone: "",
		StudioLocation: "",
		NumOfStudioDays: 0,
		ProductionManager: "",
		ProducerName: "",
		UserRole: ""
	},
	locationTypes: {
		cityBuilding: false,
		cityPark: false,
		privateAddress: false,
		privateAddress2: false,
		otherOption: false
	},
	parkingLocations: [],
	productionCompanies: [],
	roadList: [],
	intersectionList: [],
	//intersectionAry: [],
	addressNameList: [],
	Address1List: {
		road: '',
		addressList: []
	},
	Address2List: {
		road: '',
		addressList: []
	},
	facilityList: [],
	parkList: [],
	steps: {
		1: false,
		2: false,
		3: false,
		4: false,
		5: false
	},
	step: 1,
	formType: null,
	token: JSON.parse(sessionStorage.getItem('access_token')) || '',
	status: '',
	user: {},
	userLoggedIn: false,
	recoveredFormData: false,
	loading: false,
	loadingMsg: '',
	submissionDetails: {
		Id: null,
		SubmitSuccess: false
	},

	formSaveDataList: [],

	deleteFormDataDetails: {
		Id:{},
	},

	assetIdList: {},
	roadIdList: {},
	newProductionCompany: false,
	newManager: false,
	isUserLocManager: true,
	weatherDate: false,
	prepDate: false,
	wrapDate: false,
	SavedFormDataStep:'',
	formSavedData: {
		Id: 0,
		UserId:0,
		FormData: '',
		//CreatedOn:'',
		DateOfCreation:'',
		CompanyName:'',
		FilmLocation:'',
		ProductionTitle:'',
		FilmingStartDate:'',
		CityGrid:'',
		Step: 0,
		ContactId:0,
		ApplicationName:'',
		IsCopied: 0,
		IsSubmitted: 0,
		IsActive: 1
		},
	savedAppId: 0,
	savedAppValidationList:[],
}